const PROD = "https://www.eliasgomesautomoveis.pt/";
const DEV = "http://localhost:3000/";

axios.defaults.baseURL = process.env.NODE_ENV === "development" ? DEV : PROD;
